export default __webpack_public_path__ + "static/media/hidecontrol_PC.3af62b71.svg";